import parse from 'html-react-parser';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import { useAppContext } from '../../providers/app-context';
import CollapsibleList from '../../ui/collapsible-list/definition';

const ProductFAQ: FunctionComponent<{
  faq: {
    question: string;
    answer: string;
  } | null;
  descriptionValues?: { supplierName: string; alvaraNumber: string | null };
}> = ({ faq, descriptionValues }) => {
  const { shippingLocation } = useAppContext();
  const { t } = useTranslation();
  const items = t('product:faqs', {}, { returnObjects: true });
  let currentItems = { ...items };
  const portugueseShippingLocation = [1, 2, 3];

  if (faq && faq.answer) {
    currentItems['faq-part'] = {
      label: t('product:faq-part'),
      description: <div dangerouslySetInnerHTML={{ __html: faq.answer }} />,
    };
  }

  if (
    shippingLocation &&
    portugueseShippingLocation.includes(shippingLocation) &&
    descriptionValues?.alvaraNumber
  ) {
    var currentItemsArray = Object.entries(currentItems);
    currentItemsArray.splice(-1, 0, [
      'product_origin',
      {
        label: t('product:product_origin.label'),
        description: t('product:product_origin.description', descriptionValues),
      },
    ]);
    currentItems = Object.fromEntries(currentItemsArray);
  }

  return (
    <CollapsibleList
      className="max-md:px-4 lg:px-0"
      items={Object.values(currentItems).map(({ label, description }) => ({
        term: label,
        description,
      }))}
      leftPadding={false}
    />
  );
};

export default ProductFAQ;
